import MainContainer from '../components/layout/MainContainer';
import MoldOrderDetail from '../components/MoldOrderDetail';
import { ActionType } from '../types/mold';
import MoldOrderDetailSkeleton from '../components/MoldOrderDetail/Skeleton';
import ErrorPage from '../components/pages/Error';
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';
import { MoldOrderDetailProvider, useMoldOrderDetailContext } from '../context/MoldOrderDetailContext';

const MoldOrderDetailContent: React.FC = () => {
  const {
    moldOrder,
    loading,
    error,
    errorStatus,
    updateMoldOrderStatus,
    updateMoldOrderStateInstance,
    updateMoldOrder,
    updateMoldOrderDetail,
    downloadPdfReport,
  } = useMoldOrderDetailContext();

  // Get breadcrumb information based on navigation source
  const { breadcrumbItems, showBackButton, onBack } = useBreadcrumbs({
    currentPageTitle: moldOrder ? `ใบงาน #${moldOrder.id}` : 'หน้าใบงาน'
  });

  const handleStatusUpdate = async (action: ActionType, assignedTo?: number | null | undefined) => {
    try {
      await updateMoldOrderStatus(action, assignedTo);
    } catch (err) {
      alert('ขออภัยเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      console.error('Failed to update status:', err);
    }
  };

  if (loading) {
    return (
      <MainContainer 
        breadcrumbItems={breadcrumbItems}
        showBackButton={showBackButton}
        onBack={onBack}
      >
        <MoldOrderDetailSkeleton />
      </MainContainer>
    );
  }

  if (error) {
    console.log('error', error);
    return <ErrorPage message={error} errorCode={errorStatus} />;
  }

  if (!moldOrder) {
    return <ErrorPage message={"ไม่พบข้อมูลที่คุณต้องการ"} />;
  }

  return (
    <MainContainer
      breadcrumbItems={breadcrumbItems}
      showBackButton={showBackButton}
      onBack={onBack}
    >
      <MoldOrderDetail
        moldOrder={moldOrder}
        handleStatusUpdate={handleStatusUpdate}
        updateMoldOrderStateInstance={updateMoldOrderStateInstance}
        updateMoldOrder={updateMoldOrder}
        updateMoldOrderDetail={updateMoldOrderDetail}
        downloadPdfReport={downloadPdfReport}
      />
    </MainContainer>
  );
};

const MoldOrderDetailContainer: React.FC = () => {
  return (
    <MoldOrderDetailProvider>
      <MoldOrderDetailContent />
    </MoldOrderDetailProvider>
  );
};

export default MoldOrderDetailContainer;
